// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"fd9b0ab6","97":"aea62770","207":"c5877b34","393":"f00c4868","488":"4ede2a20","508":"da51a5a7","583":"8c4e9746","632":"7ccdf414","741":"943a8e8a","947":"1d93261c"}[chunkId] + ".chunk.js";
};